"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const Leg_1 = __importDefault(require("./Leg"));
require("./Label.scss");
const LABEL_TYPES = {
    FILL: "fill",
    LINE: "line"
};
const LABEL_COLORS = {
    PRIMARY: "primary",
    DARK: "dark",
    NEGATIVE: "negative",
    POSITIVE: "positive"
};
const Label = ({ className, wrapperClassName, kind = LABEL_TYPES.FILL, color = LABEL_COLORS.PRIMARY, text = "", isAnimationDisabled = false, isLegIncluded = false }) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, wrapperClassName]);
    const classNames = (0, react_1.useMemo)(() => (0, classnames_1.default)("monday-style-label", `monday-style-label--kind-${kind}`, `monday-style-label--color-${color}`, {
        "monday-style-label--with-animation": !isAnimationDisabled,
        "monday-style-label--with-leg": isLegIncluded
    }), [kind, color, isAnimationDisabled, isLegIncluded]);
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: overrideClassName }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classNames }, { children: [(0, jsx_runtime_1.jsx)("span", { children: text }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "monday-style-label__leg-wrapper" }, { children: isLegIncluded ? (0, jsx_runtime_1.jsx)(Leg_1.default, {}) : null }))] })) })));
};
Label.colors = LABEL_COLORS;
Label.kinds = LABEL_TYPES;
exports.default = Label;
